const personalInformation = {
  path: 'personalInformation',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/personalInformation'], resolve)
}
export default personalInformation



// WEBPACK FOOTER //
// ./src/router/pages/student_user/personalInformation/index.js